export default __webpack_public_path__ + "static/media/BH Icons 30 p_Cutlery.06ef5cf0.svg";